/**
 * @Author: zpc
 * @DateTime: Created in 2021-08-12 14:00:00
 * @Description: 数据自动对接服务层
 */

import DataButtJoint from '../dataButtJoint';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import DataButtJoinApi, { DataButtJointDOI } from '../api/dataButtJointApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import AreaCascader from 'src/components/areaCascader/areaCascader';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumIsOpenStatus,{EnumIsTokenStatus} from 'src/enums/enumDataButtJoint';
import Input from 'src/types/iview/Input';
import EnumEntity from 'src/enums/enumEntity';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import alertDataButtJointModal from '../dataButtJointModal'
import EnumOperates from 'src/enums/enumOperates';

export default class DataButtJointService extends ListPageService {
    ctx: DataButtJoint;
    type: any;

    constructor(ctx: DataButtJoint) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '站点名称',
                field: 'name',
                minWidth: 80,
            },
            {
                headerName: 'MN号',
                field: 'mn',
                minWidth: 100,
            },
            {
                headerName: 'CN号',
                field: 'cn',
                minWidth: 100,
            },
            {
                headerName: '是否开启数据上传',
                field: 'is_open',
                minWidth: 60,
                cellRenderer(params) {
                    let data: DataButtJointDOI.RowDataI = params.data;
                    return EnumIsOpenStatus.findId(data.is_open).getName();
                },
            },
            {
                headerName: '是否需要验证token',
                field: 'is_token',
                minWidth: 60,
                cellRenderer(params) {
                    let data: DataButtJointDOI.RowDataI = params.data;
                    return EnumIsTokenStatus.findId(data.is_token).getName();
                },
            },
            {
                headerName: '数据上传url',
                field: 'post_url',
                minWidth: 400,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 120,
                maxWidth: 120,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        async click(params) {
                            let data: StationConfigDOI.RowDataI = params.data;
                            let res = await alertDataButtJointModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: StationConfigDOI.RowDataI = params.data;
                            await t.delete(data.id);
                        },
                    },
                ],
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await DataButtJoinApi.searchList({
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertDataButtJointModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
        ];
    }

    async delete(id: number) {
        let { code } = await DataButtJoinApi.delete({ id });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }
}